/**
 * CustomGestureNode.tsx
 * 自作ジェスチャーカードのビューコンポーネント
 */
import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import type { CustomGestureNode } from '../../types';
import { getCustomMotionLabel, useCustomMotions } from '../../config/customMotions';
import { getNodeDisplayLabel, useFlowDisplayLanguage } from '../../displayLanguage';
import { CardShell } from '../CardShell';

export const CustomGestureNodeView = memo(function CustomGestureNodeView({ data }: NodeProps<CustomGestureNode>) {
  const displayLanguage = useFlowDisplayLanguage();
  useCustomMotions(); // 作成画面での追加・削除を表示に反映させる

  return (
    <CardShell
      kind="customGesture"
      accent="blue"
      title={getNodeDisplayLabel('customGesture', displayLanguage)}
      summary={getCustomMotionLabel(data.motionId) ?? ''}
    >
      <Handle type="target" position={Position.Left} className="!bg-blue-500" />
      <Handle type="source" position={Position.Right} className="!bg-blue-500" />
    </CardShell>
  );
});
